var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerPlusFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0C20.4477 0 20 0.447715 20 1V2H19C18.4477 2 18 2.44772 18 3C18 3.55228 18.4477 4 19 4H20V5C20 5.55228 20.4477 6 21 6C21.5523 6 22 5.55228 22 5V4H23C23.5523 4 24 3.55228 24 3C24 2.44772 23.5523 2 23 2H22V1C22 0.447715 21.5523 0 21 0Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4669 8.6169C22.297 8.09138 21.7016 7.85776 21.1936 8.07463C20.6857 8.29149 20.4525 8.87941 20.6116 9.40826C21.113 11.074 21.1224 12.8572 20.6271 14.5397C20.0373 16.5433 18.7684 18.2792 17.0383 19.4493C15.3082 20.6195 13.2248 21.1509 11.1455 20.9525C9.06632 20.754 7.12102 19.8381 5.6435 18.3618C4.16598 16.8855 3.24839 14.9409 3.04823 12.8619C2.84806 10.7828 3.3778 8.69891 4.54651 6.96784C5.71523 5.23677 7.45005 3.96647 9.45321 3.37498C11.1353 2.8783 12.9185 2.88626 14.5846 3.38623C15.1136 3.54496 15.7013 3.31122 15.9178 2.80311C16.1342 2.29501 15.9001 1.69979 15.3745 1.53036C13.276 0.853957 11.0142 0.821568 8.88489 1.4503C6.43473 2.17379 4.31278 3.72755 2.88327 5.84491C1.45375 7.96227 0.805798 10.5112 1.05063 13.0542C1.29547 15.5972 2.41781 17.9757 4.22504 19.7814C6.03227 21.5871 8.41167 22.7075 10.9549 22.9502C13.4981 23.193 16.0464 22.5429 18.1626 21.1117C20.2788 19.6804 21.8308 17.5572 22.5523 15.1064C23.1792 12.9766 23.145 10.7148 22.4669 8.6169Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15V16C14 16.5523 13.5523 17 13 17C12.4477 17 12 16.5523 12 16V15H10C9.44772 15 9 14.5523 9 14V13.2361C9 13.0808 9.03615 12.9277 9.10557 12.7889L11.7236 7.55279C11.893 7.214 12.2393 7 12.618 7H13C13.5523 7 14 7.44772 14 8V13C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15 14 15ZM12 11L11 13H12V11Z",
    fill: "#efefef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerPlusFour);
export default __webpack_public_path__ + "static/media/cornerPlusFour.4770d553d28f03d056dd374521ae82c3.svg";
export { ForwardRef as ReactComponent };